<template>
    <div v-if="showNotification" class="price-notification ion-text-center">
        <p class="ma-0 color-black bold">
            Changing location may mean different prices, menu items, or
            {{ isDelivery ? 'delivery may take more time' : 'longer wait times' }}.
            <!-- TODO: tests this further, find solution to maintain page stacks -->
            <!--  I think this will break if a user navigates to /location -> /location/:storeLocation  -->
            <a @click="router.back()" class="no-underline color-primary">Go Back</a>
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
    props: { isDelivery: Boolean, showNotification: Boolean },
    setup() {
        const router = useRouter();
        return { router };
    },
});
</script>

<style scoped>
.price-notification {
    background: var(--ion-color-segment-background);
    padding: 12px;
}
</style>
